module.exports = __webpack_public_path__ + "static/media/connected-river-interreg-ns-vertical.4a46d64e.png";